module.exports = __webpack_public_path__ + "img/button_delete_icon.fe4d42cd.svg";